<template>
    <b-jumbotron class="py-5">
        <keep-alive include="AdminCoursesList">
            <router-view />
        </keep-alive>
    </b-jumbotron>
</template>

<script>
export default {
    name: 'AdminCourses',
    data () {
        return {}
    }
}
</script>
